@if (editMode()) {
    <form #form="ngForm" [class.ng-submitted]="submitted()">
        <ng-container *ngTemplateOutlet="editModeDirective.template"></ng-container>
    </form>
} @else {
    <button type="button"
            class="btn btn-light click2edit truncate"
            (click)="displayEditMode()"
            *transloco="let t"
            [attr.aria-label]="t('COMMON.CLICK_TO_EDIT', {label: label()})"
            [style.white-space]="multiline() ? 'pre-wrap': 'nowrap'"
            [class.placeholder]="!text()"
            [tooltip]="label()"
    >{{ content() }}</button>
    <!-- don't change formatting -->
}
